import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["drawer", "overlay"]

  connect() {
    this.isOpen = false
    this._onKeydown = this._handleKeydown.bind(this)
    document.addEventListener("keydown", this._onKeydown)
  }

  disconnect() {
    document.removeEventListener("keydown", this._onKeydown)
    this.isOpen = false
  }

  _handleKeydown(e) {
    if (e.key === "Escape" && this.isOpen) this.close()
  }

  toggle() {
    this.isOpen ? this.close() : this.open()
  }

  open() {
    this.isOpen = true
    this.drawerTarget.classList.add("edu-drawer--open")
    this.overlayTarget.classList.add("edu-drawer-overlay--visible")
  }

  close() {
    this.isOpen = false
    this.drawerTarget.classList.remove("edu-drawer--open")
    this.overlayTarget.classList.remove("edu-drawer-overlay--visible")
  }
}
